// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"2ed0b253","159":"cc683f6c","453":"0e96f6f4","484":"ad5afb9b","595":"7b7f47f4","732":"d0f63bd4","930":"fdfe8527"}[chunkId] + ".chunk.js";
};